// @flow
import React, { Component } from 'react';
import type { EventSequence } from 'store/modules/events';
import { connect } from 'react-redux';
import type { State } from 'store';

import EventSequences from 'components/event/EventSequences/EventSequences';

type Props = {
  sequences: ?(EventSequence[]),
  username: string,
  currentEventId: string,
};

class EventSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentEventId } = this.props;

    return (
      <EventSequences sequences={sequences} username={username} currentEventId={currentEventId} />
    );
  }
}

export default connect(
  ({ events }: State) => ({
    sequences: events.sequences,
    currentEventId: events.event && events.event.id,
  }),
  () => ({}),
)(EventSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/event/EventSequencesContainer.js